// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SetRegionalPreReleaseRequest
 */
export interface SetRegionalPreReleaseRequest {
  /**
   *
   * @type {string}
   * @memberof SetRegionalPreReleaseRequest
   */
  note?: string;
}

/**
 * Check if a given object implements the SetRegionalPreReleaseRequest interface.
 */
export function instanceOfSetRegionalPreReleaseRequest(
  value: object,
): value is SetRegionalPreReleaseRequest {
  return true;
}

export function SetRegionalPreReleaseRequestFromJSON(
  json: any,
): SetRegionalPreReleaseRequest {
  return SetRegionalPreReleaseRequestFromJSONTyped(json, false);
}

export function SetRegionalPreReleaseRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetRegionalPreReleaseRequest {
  if (json == null) {
    return json;
  }
  return {
    note: json['note'] == null ? undefined : json['note'],
  };
}

export function SetRegionalPreReleaseRequestToJSON(
  json: any,
): SetRegionalPreReleaseRequest {
  return SetRegionalPreReleaseRequestToJSONTyped(json, false);
}

export function SetRegionalPreReleaseRequestToJSONTyped(
  value?: SetRegionalPreReleaseRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    note: value['note'],
  };
}
